var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "prescription-print",
      staticStyle: {
        margin: "0",
        padding: "25px 40px",
        background: "#fff",
        width: "100%",
      },
    },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "patient-details",
          staticStyle: { "min-height": "90px" },
        },
        [
          _c(
            "table",
            {
              staticStyle: {
                "font-size": "16px",
                width: "400px",
                "margin-bottom": "20px",
                "font-family": "arial, sans-serif",
                "border-collapse": "collapse",
                border: "0 !important",
                "table-layout": "fixed",
              },
              attrs: {
                border: "0 !important",
                cellspacing: "0",
                cellpadding: "0",
              },
            },
            [
              _c("tbody", { staticStyle: { border: "0 !important" } }, [
                _c(
                  "tr",
                  {
                    staticStyle: { background: "none", border: "0 !important" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "2px 0",
                          border: "0 !important",
                          "text-align": "left",
                          "font-family":
                            "'Poppins', arial, sans-serif !important",
                          "font-size": "14px",
                          "line-height": "1.5",
                        },
                      },
                      [_vm._v("\n            Patient name\n          ")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "2px 0",
                          border: "0",
                          "text-align": "left",
                          "font-family":
                            "'Poppins', arial, sans-serif !important",
                          "font-size": "14px",
                          "line-height": "1.5",
                        },
                      },
                      [
                        _vm._v(
                          "\n            :\n            " +
                            _vm._s(
                              _vm.patient.firstname || _vm.patient.lastname
                                ? (_vm.patient.firstname || "") +
                                    (_vm.patient.lastname
                                      ? " " + _vm.patient.lastname
                                      : "")
                                : _vm.patient.name
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "tr",
                  {
                    staticStyle: { background: "none", border: "0 !important" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "2px 0",
                          border: "0 !important",
                          "text-align": "left",
                          "font-family":
                            "'Poppins', arial, sans-serif !important",
                          "font-size": "14px",
                          "line-height": "1.5",
                        },
                      },
                      [_vm._v("\n            Registration No.\n          ")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "2px 0",
                          border: "0 !important",
                          "text-align": "left",
                          "font-family":
                            "'Poppins', arial, sans-serif !important",
                          "font-size": "14px",
                          "line-height": "1.5",
                        },
                      },
                      [
                        _vm._v(
                          "\n            : " +
                            _vm._s(_vm.patient.patient_RegId) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "tr",
                  {
                    staticStyle: { background: "none", border: "0 !important" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "2px 0",
                          border: "0 !important",
                          "text-align": "left",
                          "font-family":
                            "'Poppins', arial, sans-serif !important",
                          "font-size": "14px",
                          "line-height": "1.5",
                        },
                      },
                      [_vm._v("\n            Age / Sex\n          ")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "2px 0",
                          border: "0 !important",
                          "text-align": "left",
                          "font-family":
                            "'Poppins', arial, sans-serif !important",
                          "font-size": "14px",
                          "line-height": "1.5",
                        },
                      },
                      [
                        _vm._v(
                          "\n            : " +
                            _vm._s(_vm.displayAge) +
                            "y / " +
                            _vm._s(_vm.patient.gender) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "rx-img", staticStyle: { "margin-bottom": "5px" } },
        [
          _c("p", { staticStyle: { padding: "10px 0" } }, [
            _vm._v("\n      Date: "),
            _c("span", { staticStyle: { "font-weight": "normal" } }, [
              _vm._v(_vm._s(_vm.time)),
            ]),
          ]),
          _c("img", {
            attrs: { src: require("@/static/images/rx.png"), alt: "" },
          }),
        ]
      ),
      _c(
        "table",
        {
          staticClass: "main-table",
          staticStyle: {
            "font-family": "arial, sans-serif",
            "font-size": "14px",
            "border-collapse": "collapse",
            border: "0 !important",
            "border-bottom": "1px solid #000000 !important",
            "table-layout": "fixed",
            width: "760px",
          },
          attrs: { border: "0", cellspacing: "0", cellpadding: "0" },
        },
        [
          _vm._m(1),
          _c(
            "tbody",
            { staticStyle: { border: "0 !important" } },
            _vm._l(_vm.selectedItemsData, function (item) {
              return _c(
                "tr",
                { key: item.itemId, staticStyle: { border: "0 !important" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        "text-align": "left",
                        padding: "10px 20px",
                        border: "0 !important",
                        "font-family":
                          "'Poppins', arial, sans-serif !important",
                        "font-size": "14px",
                        "line-height": "1.5",
                      },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.getItemName(item, "te"))),
                      ]),
                      _vm.selectedLanguage && _vm.selectedLanguage !== "te"
                        ? _c("span", { staticClass: "other-language-name" }, [
                            _vm._v(
                              "\n            (" +
                                _vm._s(
                                  _vm.getItemName(item, _vm.selectedLanguage)
                                ) +
                                ")\n          "
                            ),
                          ])
                        : _vm._e(),
                      _c("br"),
                      _c("div", { staticClass: "description-te" }, [
                        _c("p", { staticClass: "prescription-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getLanguageDesc(item, "te")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm.selectedLanguage && _vm.selectedLanguage !== "te"
                        ? _c("div", { staticClass: "description-other-lang" }, [
                            _c("p", { staticClass: "prescription-text" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.getLanguageDesc(
                                      item,
                                      _vm.selectedLanguage
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("br"),
      _c(
        "table",
        {
          staticClass: "signature-table",
          staticStyle: {
            "font-family": "arial, sans-serif",
            "font-size": "14px",
            "border-collapse": "collapse",
            border: "0 !important",
            "border-bottom": "1px solid #000000 !important",
            "table-layout": "fixed",
            width: "760px",
          },
          attrs: { cellspacing: "0", cellpadding: "0" },
        },
        [
          _c("tbody", { staticStyle: { border: "0 !important" } }, [
            _c("tr", { staticStyle: { border: "0 !important" } }, [
              _c(
                "td",
                {
                  staticStyle: {
                    "text-align": "right",
                    padding: "10px 20px",
                    "font-weight": "bold",
                    border: "0 !important",
                    "font-family": "'Poppins', arial, sans-serif !important",
                    "font-size": "14px",
                    "line-height": "1.5",
                  },
                },
                [_vm._v("\n          " + _vm._s(_vm.doctorName) + "\n        ")]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "header",
        staticStyle: {
          width: "100%",
          padding: "0 0 12px 0",
          position: "relative",
          display: "flex",
          "justify-content": "space-between",
        },
      },
      [
        _c(
          "div",
          { staticClass: "header-left", staticStyle: { width: "50%" } },
          [
            _c("img", {
              staticStyle: { "max-width": "120px" },
              attrs: {
                src: "https://genamet-static-uploads-prod.s3.ap-south-1.amazonaws.com/9081555f-68f9-4d4d-835f-824d6a435dd9/images/logo/064d5b75-bea2-4715-a9d7-0429629b0455.png",
              },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "header-right",
            staticStyle: { width: "50%", "text-align": "right" },
            attrs: { hidden: "" },
          },
          [
            _c("img", { attrs: { src: "" } }),
            _c("span"),
            _c("p"),
            _c("span", [
              _c("input", { attrs: { type: "checkbox" } }),
              _vm._v("Show Header"),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticStyle: { border: "0 !important" } }, [
      _c("tr", { staticStyle: { border: "0 !important" } }, [
        _c(
          "th",
          {
            staticStyle: {
              border: "0 !important",
              "border-top": "1px solid #000000 !important",
              "border-bottom": "1px solid #000000 !important",
              "text-align": "left",
              padding: "3px 15px",
            },
          },
          [_vm._v("\n          Medicine Name\n        ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }